module.exports = {"320413001":"西城街道","320413100":"金城镇","320413104":"儒林镇","320413106":"直溪镇","320413108":"朱林镇","320413109":"薛埠镇","320413112":"指前镇","320413400":"开发区","320413401":"茅山旅游度假区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320413.json
// module id = 798
// module chunks = 0